import { render } from "./PrescriberProxyUserDetails.vue?vue&type=template&id=98afd39a&scoped=true"
import script from "./PrescriberProxyUserDetails.vue?vue&type=script&lang=js"
export * from "./PrescriberProxyUserDetails.vue?vue&type=script&lang=js"

import "./PrescriberProxyUserDetails.vue?vue&type=style&index=0&id=98afd39a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98afd39a"]])

export default __exports__